import type { CSSObject } from '@emotion/react';

import type {
  ThemeType,
} from '@n3/css-base';

export const createContainerStyle = ({
  colors,
}: ThemeType) => (baseCSS: CSSObject): CSSObject => ({
  ...baseCSS,
  borderRadius: 4,
  backgroundColor: colors.NEUTRAL_WHITE,
  boxShadow: '0px 4px 8px rgba(148, 148, 148, 0.24)',
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: colors.NEUTRAL_INACTIVE,
});
